const clientTourSteps = [
  {
    target: '[data-v-step="tour-studio"]',
    content: "Edit your module here.",
    params: {
      enableScrolling: false,
      strategy: "fixed",
      placement: "right"
    }
  },
  {
    target: '[data-v-step="tour-invite-user"]',
    content:
      "Invite your teammates to the workspace and start collaborating together.",
    params: {
      enableScrolling: false,
      strategy: "fixed",
      placement: "right"
    }
  },
  {
    target: '[data-v-step="tour-manage-user"]',
    content: "You can manage the users in your workspace here.",
    params: {
      enableScrolling: false,
      strategy: "fixed",
      placement: "right"
    }
  },
  {
    target: '[data-v-step="tour-calendar"]',
    content: "You can view calendar here.",
    params: {
      enableScrolling: false,
      strategy: "fixed",
      placement: "right"
    }
  },
  {
    target: '[data-v-step="tour-dashboard"]',
    content: "You can view dashboard here.",
    params: {
      enableScrolling: false,
      strategy: "fixed",
      placement: "right"
    }
  }
];

const clientCreateEntrySteps = [
  {
    id: "tour-create-entry",
    target: '[data-v-step="tour-create-entry"]',
    content: "Click to create new entry.",
    params: {
      enableScrolling: false,
      strategy: "fixed",
      placement: "right"
    }
  }
];

const studioTourSteps = [
  {
    target: '[data-v-step="studio-tour-create-module"]',
    content: "Create a new module with custom fields, tables and lists.",
    params: {
      placement: "top"
    }
  },
  {
    target: '[data-v-step="studio-tour-help"]',
    content: "I want to take a tour of Inistate Studio again",
    params: {
      placement: "right"
    }
  },
  {
    target: '[data-v-step="studio-tour-invite-user"]',
    content:
      "Invite your teammates to the workspace and start collaborating together.",
    params: {
      placement: "right"
    }
  },
  {
    target: '[data-v-step="studio-tour-manage-user"]',
    content: "You can manage the users in your workspace here.",
    params: {
      placement: "right"
    }
  },
  {
    target: '[data-v-step="studio-tour-workspace-settings"]',
    content: "Edit your workspace settings here.",
    params: {
      placement: "bottom-end"
    }
  }
];

const moduleRunSteps = [
  {
    target: '[data-v-step="studio-tour-run"]',
    content: "Click to run app",
    params: {
      enableScrolling: false,
      strategy: "fixed"
    }
  }
];

const moduleStartSteps = [
  {
    target: '[data-v-step="studio-tour-start"]',
    content: "Click to start to configure this module",

    params: {
      enableScrolling: false
    }
  }
];

const liteTourSteps = [
  {
    target: '[data-v-step="welcome"]',
    header: {
      title: "Welcome 👋"
    },
    content:
      "We’re excited to have you here! Take a quick tour to get started.",
    params: {
      placement: "right"
    }
  },
  {
    target: '[data-v-step="modules-listings"]',
    header: {
      title: "Stay organised"
    },
    content:
      "You can group related work together by creating modules & listings.",
    params: {
      placement: "right-start",
      strategy: "fixed",
      enabledButtons: {
        buttonPrevious: false
      }
    }
  },
  {
    target: '[data-v-step="all-tasks"]',
    header: {
      title: "Overview of all tasks"
    },
    content:
      "Fill in information you need and organise them to match your workflow.",
    params: {
      placement: "bottom-end",
      strategy: "fixed",
      enabledButtons: {
        buttonPrevious: false
      }
    }
  },
  {
    target: '[data-v-step="workflows"]',
    header: {
      title: "Automate status update"
    },
    content: "Use flows to auto-update status when an action occurs.",
    params: {
      strategy: "fixed",
      enabledButtons: {
        buttonPrevious: false
      }
    }
  },
  {
    target: '[data-v-step="web"]',
    header: {
      title: "Published instantly"
    },
    content:
      "With one click, your workspace goes live, ready for collaboration.",
    params: {
      strategy: "fixed",
      enabledButtons: {
        buttonPrevious: false
      }
    }
  },
  {
    target: '[data-v-step="mobile"]',
    header: {
      title: "Mobile-ready"
    },
    content: "Access your workspace seamlessly across any device, anytime.",
    params: {
      strategy: "fixed",
      enabledButtons: {
        buttonPrevious: false
      }
    }
  },
  {
    target: '[data-v-step="mobile"]',
    header: {
      title: "You’ve completed the tour 🎉"
    },
    content:
      "Ready to build? Switch to Editor mode and bring your ideas to life!",
    params: {
      strategy: "fixed",
      enabledButtons: {
        buttonPrevious: false,
        buttonSkip: false
      }
    }
  }
];

export default {
  clientTourSteps: clientTourSteps,
  clientCreateEntrySteps,
  clientCreateEntrySteps,
  studioTourSteps: studioTourSteps,
  moduleRunSteps: moduleRunSteps,
  moduleStartSteps: moduleStartSteps,
  liteTourSteps: liteTourSteps
};
